import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'programsCategoryList';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_MORE_SUCCESS = `${namespace}/fetch-more-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			request({}, FETCH_DATA_SUCCESS)(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data.rows,
			isLoading: false,
			isError: false
		}),
		[FETCH_MORE_SUCCESS]: (state, action) => ({
			...state,
			data: state.data.concat(action.payload.data.rows),
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field]
};

function request(query, successActionType) {
	return http({
		url: endpoints.OFFER_CATEGORIES.BASE,
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/category/list/index.js